define('model/current.user.decision.model',['require','exports','module','underscore','./disclosure.decision.model','datakit/datakit','model/outcome.model'],function(require, exports, module) {
  //prettier-ignore
  var _            = require('underscore'),
      BaseModel    = require('./disclosure.decision.model'),
      DataKit      = require('datakit/datakit'),
      OutcomeModel = require('model/outcome.model');

  var CurrentUserDecisionModel = BaseModel.extend({
    radioRequests: {
      'models CurrentUserDecisionModel': '@constructor',
    },

    childModels: {
      outcome: OutcomeModel,
    },

    relationshipTypes: {
      hasOne: DataKit.AbstractHasOneRelationshipType.extend({
        supportedForeignKey: 'documentId',
        configureResource: function() {
          this.resource.set(this.foreignKey, this.foreignModel.id);
        },
      }),
    },

    fetchUrlTemplate: '/api/v1/compliance/disclosure/:documentId/session/decision',

    saveUrlTemplate: '/api/v1/compliance/disclosure/:documentId/decision',

    fetch: function(options) {
      return BaseModel.prototype.fetch.call(
        this,
        _.extend(
          {
            url: DataKit.url.template(this.fetchUrlTemplate, this),
          },
          options
        )
      );
    },

    save: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: DataKit.url.template(this.saveUrlTemplate + '/' + this.id, this, {
              documentId: this.get('documentId'),
            }),
          },
          options
        )
      );
    },
  });

  module.exports = CurrentUserDecisionModel;
});

